import { PurchaseOrderBundle } from '@/services/api/contracts/catalog/bundles';
import { useMemo } from 'react';
import { usePurchaseOrderDetails } from './usePurchaseOrderDetails';

export const usePurchaseOrderMainDeviceCount = (order?: PurchaseOrderBundle) => {
  const { products } = usePurchaseOrderDetails(order);

  const mainDeviceCount = useMemo(() => {
    const mainDevices = products.filter(p => p.category.isMainDevice);

    const totalCount = mainDevices.reduce(
      (sum, item) => sum + (order?.bundledItems.find(o => o.catalogItem === item.id)?.count ?? 0),
      0
    );

    return totalCount;
  }, [products]);

  return mainDeviceCount;
};
